import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../App.css';
import { Line, Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const MetricsScreen = () => {
  const [chartData, setChartData] = useState({});
  const [timeframe, setTimeframe] = useState('all');

  const fetchChartData = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/prompts/`);
      const metrics = response.data;

      const promptTokenData = {
        labels: metrics.map(p => new Date(p.created_at).toLocaleTimeString()),
        datasets: [
          {
            label: 'Prompt Tokens Used',
            data: metrics.map(p => p.prompt_token_usage),
            borderColor: 'rgb(75, 192, 192)',
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
          },
        ],
      };

      const responseTokenData = {
        labels: metrics.map(p => new Date(p.created_at).toLocaleTimeString()),
        datasets: [
          {
            label: 'Response Tokens Used',
            data: metrics.map(p => p.response_token_usage),
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
          },
        ],
      };

      const costPerPromptData = {
        labels: metrics.map(p => new Date(p.created_at).toLocaleTimeString()),
        datasets: [
          {
            label: 'Cost Per Prompt',
            data: metrics.map(p => p.cost),
            borderColor: 'rgb(54, 162, 235)',
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
          },
        ],
      };

      const costOverTimeData = await fetchCostOverTimeData(timeframe);

      setChartData({ promptTokenData, responseTokenData, costPerPromptData, costOverTimeData });

    } catch (err) {
      console.error('Error fetching chart data:', err);
    }
  };

  const fetchCostOverTimeData = async (timeframe) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/metrics/cost?timeframe=${timeframe}`);
      return {
        labels: [timeframe],
        datasets: [
          {
            label: `Cost in last ${timeframe}`,
            data: [response.data.total_cost],
            borderColor: 'rgb(255, 206, 86)',
            backgroundColor: 'rgba(255, 206, 86, 0.2)',
          },
        ],
      };
    } catch (err) {
      console.error('Error fetching cost over time data:', err);
      return {};
    }
  };

  useEffect(() => {
    fetchChartData();
    const interval = setInterval(fetchChartData, 5000); // Refetch every 5 seconds
    return () => clearInterval(interval);
  }, [timeframe]);

  return (
    <div className="App">
        <div className="timeframe-selector">
            <select value={timeframe} onChange={(e) => setTimeframe(e.target.value)}>
                <option value="1m">Last Minute</option>
                <option value="30m">Last 30 Minutes</option>
                <option value="1h">Last Hour</option>
                <option value="3h">Last 3 Hours</option>
                <option value="12h">Last 12 Hours</option>
                <option value="1d">Last Day</option>
                <option value="1w">Last Week</option>
                <option value="1mo">Last Month</option>
                <option value="all">All Time</option>
            </select>
        </div>
        <div className="charts-container">
          {chartData.promptTokenData && <div className="chart-card"><Line data={chartData.promptTokenData} /></div>}
          {chartData.responseTokenData && <div className="chart-card"><Line data={chartData.responseTokenData} /></div>}
          {chartData.costPerPromptData && <div className="chart-card"><Bar data={chartData.costPerPromptData} /></div>}
          {chartData.costOverTimeData && <div className="chart-card"><Bar data={chartData.costOverTimeData} /></div>}
        </div>
    </div>
  );
};

export default MetricsScreen;